import Button from "../Button";
import Icon from "../icons/Icon";
import Notiz from "../Notiz";
import Sheet from "../Sheet";
import { WartePunkte } from "../StatusPille";
import { istQuizPlayer } from "../../spotifyPlayer";
import "./GeraeteDialog.css";

const ART = {
  Smartphone: ["handy", "Handy"],
  Tablet: ["handy", "Tablet"],
  Computer: ["computer", "Computer"],
  Speaker: ["box", "Lautsprecher"],
  AVR: ["box", "Verstärker"],
  CastAudio: ["box", "Lautsprecher"],
  TV: ["computer", "Fernseher"],
  CastVideo: ["computer", "Fernseher"],
};
const art = (typ) => ART[typ] || ["lautsprecher", typ || "Gerät"];

/**
 * Spotify-Geraet waehlen. Das eigene Browser-Geraet ("Dieses Geraet") steht
 * immer oben — es ist das einzige, das nicht einschlafen kann.
 */
export function GeraeteDialog({
  devices,
  devicesLoading,
  deviceError,
  sdkGeraetId,
  sdkFehler,
  sdkBrauchtNeuanmeldung,
  onActivate,
  onReload,
  onReconnect,
  onOpenDiag,
  onClose,
}) {
  const liste = [...devices]
    // Nach einem Reload haengt der alte Quiz-Player bei Spotify noch
    // minutenlang nach. Zwei Eintraege gleichen Namens, von denen einer tot
    // ist, sind schlimmer als keine Auswahl.
    .filter((d) => !istQuizPlayer(d.name) || d.id === sdkGeraetId)
    .sort((a, b) => (b.id === sdkGeraetId ? 1 : 0) - (a.id === sdkGeraetId ? 1 : 0));

  return (
    <Sheet
      titel="Gerät wählen"
      mitX
      onClose={onClose}
      fuss={
        <Button variant="text" className="geraete-protokoll" onClick={onOpenDiag}>
          <Icon name="info" />
          Verbindungs-Protokoll
        </Button>
      }
    >
      {deviceError && <Notiz art="fehler">{deviceError}</Notiz>}

      {devicesLoading ? (
        <div className="geraete-leer" role="status">
          Suche Geräte <WartePunkte />
        </div>
      ) : liste.length === 0 && !deviceError ? (
        <div className="geraete-leer">
          <span className="geraete-leer-ikon">
            <Icon name="lautsprecher" />
          </span>
          <b>Kein Gerät gefunden</b>
          <span>Öffne Spotify auf Handy, PC oder Box und spiel kurz etwas ab. Dann „Neu suchen“.</span>
        </div>
      ) : (
        <ul className="geraete">
          {liste.map((d) => {
            const hier = !!sdkGeraetId && d.id === sdkGeraetId;
            const [icon, typ] = hier ? ["handy", "Ton kommt aus dem Quiz"] : art(d.type);
            return (
              <li key={d.id}>
                <button type="button" className={`geraet${hier ? " hier" : ""}`} onClick={() => onActivate(d)}>
                  <span className={`geraet-ikon${hier ? "" : " blau"}`}>
                    <Icon name={icon} />
                  </span>
                  <span className="geraet-text">
                    {/* "Empfohlen" steht in der Namenszeile, nicht als dritte
                        Spalte: neben "Aktiv" blieben auf schmalen Handys sonst
                        34 px fuer "Ton kommt aus dem Quiz" — ein Wort pro Zeile. */}
                    <span className="geraet-name">
                      <b>{hier ? "Dieses Gerät" : d.name}</b>
                      {hier && <span className="geraet-empfohlen">Empfohlen</span>}
                    </span>
                    <small>{typ}</small>
                  </span>
                  {d.is_active && (
                    <span className="geraet-aktiv">
                      <i />
                      Aktiv
                    </span>
                  )}
                </button>
              </li>
            );
          })}
        </ul>
      )}

      {sdkFehler && (
        <>
          <Notiz art="fehler">
            <b>Wiedergabe im Quiz nicht möglich:</b> {sdkFehler}
          </Notiz>
          {sdkBrauchtNeuanmeldung && (
            <Button variant="neben" onClick={onReconnect}>
              <Icon name="nochmal" />
              Neu verbinden (Punkte bleiben)
            </Button>
          )}
        </>
      )}

      <div className="reihe">
        <Button variant="neben" onClick={onReload}>
          <Icon name="nochmal" />
          Neu suchen
        </Button>
        {/* Nur mit dem Handy als Host: Spotify muss dort laufen, damit es als
            Geraet sichtbar bleibt. Der Link oeffnet die App, sonst den Web-Player. */}
        <a className="knopf neben" href="spotify:" target="_blank" rel="noreferrer" onClick={() => setTimeout(onReload, 1500)}>
          <Icon name="play" />
          Spotify öffnen
        </a>
      </div>

      <Notiz>
        <b>Host nur mit Handy?</b> Dann „Dieses Gerät“ nehmen. Über die Spotify-App auf demselben Handy bricht die
        Verbindung bei jeder Pause ab.
      </Notiz>
    </Sheet>
  );
}

export default GeraeteDialog;
